import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { DropdownMenu, DropdownItem, DropdownToggle, ListGroupItem, Row, Col, Dropdown } from 'reactstrap';

import './style.css';
import { Badge } from 'antd';
import { useHistory } from 'react-router';
import { useQuery, useQueryClient } from 'react-query';
import { renderLongText } from 'utils/convertValue';
import { getNotificationListApi, updateNotificationStatusApi } from 'pages/Notifications/api/NotificationApis';
import { useSelector } from 'react-redux';

function Notification({ color = 'white' }) {
  const history = useHistory();
  const loggedInUser = useSelector((state) => state.authReducer.loggedInUser);
  const [isOpenBell, setIsOpenBell] = useState(false);
  const [count, setCount] = React.useState(0);
  const queryClient = useQueryClient();

  const KEY_GET_NOTIFICATIONS = 'p_SACHSO_ThongBao_NguoiDung_DanhSach';
  const { data: notificationList, isLoading } = useQuery(
    KEY_GET_NOTIFICATIONS,
    () =>
      getNotificationListApi({
        UserId: loggedInUser?.id ?? 0,
        PageNum: 1,
        PageSize: 8,
      }),
    {
      refetchInterval: 1 * 60 * 1000, // 1 phút làm mới thông báo một lần
    },
  );

  //đếm số thông báo chưa đọc
  useEffect(() => {
    if (notificationList) {
      const count = notificationList.filter((item) => item.status === 0).length;
      setCount(count);
    }
  }, [notificationList]);

  const toggleDropdown = () => {
    setIsOpenBell((pre) => !pre);
  };
  const handleNotificationSetting_SUBMIT_ASSIGNMENT = (setting) => {
    const { classId, assignmentId, studentId, exerciseType } = setting;
    history.push(`/lms/teacher/classes/${classId}/classwork/assignments/${assignmentId}/details/${exerciseType}`);
  };
  const handleNotificationSetting_MARK_ASSIGNMENT = (setting) => {
    const { classId, assignmentId, studentId, exerciseType } = setting;
    history.push(`/lms/student/classes/${classId}/classwork/assignments/${assignmentId}/details`);
  };

  const onClickNotificationItem = async (data) => {
    setIsOpenBell(false);
    if (data?.thongBaoId) {
      await updateNotificationStatusApi({ ThongBaoId: data?.thongBaoId, UserId: loggedInUser.id, TrangThai: 1 }).then(() => {
        queryClient.invalidateQueries(KEY_GET_NOTIFICATIONS);
      });
      if (data.setting) {
        const setting = data.setting ? data.setting : {};
        switch (setting.type) {
          case 'SUBMIT_ASSIGNMENT':
            handleNotificationSetting_SUBMIT_ASSIGNMENT(setting);
            return;
          case 'GIVE_ASSIGNMENT':
          case 'MARK_ASSIGNMENT':
            handleNotificationSetting_MARK_ASSIGNMENT(setting);
            return;
          case 'CLASS_NOTIFICATION':
            history.push(`/lms/student/classes/${setting.classId}?tab=notifications`);
            return;
          default:
            break;
        }
      }
      history.push(`/lms/notifications?id=${data.thongBaoId}`);
    } else {
      history.push('/lms/notifications');
    }
  };

  return (
    <Dropdown nav isOpen={isOpenBell} toggle={toggleDropdown}>
      <DropdownToggle className='nav-link' color='' tag='a' style={{ cursor: 'pointer' }}>
        {/* Nếu thông báo > 9, offset dịch sang phải 8px. */}
        <Badge count={count} offset={count > 9 ? [8, 0] : [0, 0]} overflowCount={9} size={'small'}>
          {/* Màu color của .ant-badge ảnh hưởng tới màu icon, nên style color inline. */}
          <i
            className='ni ni-bell-55'
            style={{
              color: color,
              fontSize: 20,
            }}
          />
        </Badge>
      </DropdownToggle>
      <DropdownMenu className='dropdown-menu-xl py-0 overflow-hidden' right>
        <div className='px-3 py-3'>
          <h6 className='text-sm text-muted m-0'>
            Bạn có <strong className='text-info'>{count}</strong> thông báo chưa đọc.
          </h6>
        </div>
        <div style={{ maxHeight: 'calc( 100vh - 200px )', overflowY: 'auto' }}>
          {/* Hiển thị 8 thông báo mới nhất */}
          {notificationList?.map((data) => {
            return (
              <ListGroupItem key={data.id} className='list-group-item-action' onClick={() => onClickNotificationItem(data)} style={{ cursor: 'pointer' }}>
                <Row className='align-items-center'>
                  <Col className='col-auto'>
                    <Badge dot={data.status === 0}>{data.avatar ? <img alt='...' className='avatar rounded-circle' src={data.avatar} /> : <i className='ni ni-bell-55 avatar rounded-circle' style={{ backgroundColor: '#11CEEF' }} />}</Badge>
                  </Col>
                  <div className='col ml--2'>
                    <div className='d-flex justify-content-between align-items-center'>
                      <div>
                        <h4 className='mb-0 text-sm'>{renderLongText(data.title ?? '', 67)}</h4>
                      </div>
                      <div className='text-right text-muted'>
                        <small>{moment(data.createDate).locale('vi').fromNow()}</small>
                      </div>
                    </div>
                    <div className='text-sm mb-0' dangerouslySetInnerHTML={{ __html: data.content ?? '' }} style={{ height: 30, overflowY: 'hidden' }} />
                  </div>
                </Row>
              </ListGroupItem>
            );
          })}
        </div>

        <DropdownItem className='text-center text-info font-weight-bold py-3' href='#pablo' onClick={() => onClickNotificationItem()}>
          Xem tất cả
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default Notification;
